export const productsList = {
    edc15: [
        {
            price: 65,
            name: "TMS",
            description: "Mapswitch with cruise control",
        },
        {
            price: 65,
            name: "TMS",
            description: "Mapswitch with pedals",
        },
    ],
    med9: [
        {
            price: 125,
            name: "TMS",
            description: "Mapswitch with pedals",
        },
        {
            price: 125,
            name: "TMS",
            description: "Mapswitch with cruise control",
        },
        {
            price: 200,
            name: "TMS",
            description: "Mapswitch with pedals MED9.1.5",
        },
        {
            price: 200,
            name: "TMS",
            description: "Mapswitch with cruise control MED9.1.5",
        },
    ],
};
